<template>
    <div>
        <div class="row pattern-dark">
            <section class="gallery" id="gallery">
                <div class="container">
                    <div class="row">
                        <div class="shs">
                            <img src="@/assets/img/stormhaven-logo.small.png" alt="Stormhave Studios Logo" />
                        </div>
                        <p class="section-description" style="margin: 0 auto;" >
                            Embers Adrift is under development by
                        </p>
                        <div class="shs-title">
                             <a href="https://www.stormhavenstudios.com" target="_blank" alt="Stormhaven Studios">Stormhaven Studios</a> 
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div class="Divider">
            <hr class="Divider-rule">
        </div>
        <div class="row">
            <section class="team" id="team">
                <div class="container">
                    <div class="row">
                        <h2>The Team</h2>
                    </div>
                    <div class="left-team">
                        <section class="col-md-4">
                            <img src="@/assets/img/team/Bearded-Gamer-Drindin.jpg" alt="John Gust">
                        </section>
                        <section class="col-md-8">
                            <blockquote>
                                Games have always been a passion of mine, particularly when they bring people together. That is why I love MMORPGs so much. My first MMORPG was EQ and I loved it and fell in love with the genre. Now I want to help bring back the things that made classic MMORPGs so near and dear to our gamer hearts and introduce them to those who may never have had a chance to experience them.
                            </blockquote>
                            <p>
                                <strong>John Gust</strong>, Executive Producer
                            </p>
                        </section>
                    </div>
                    <div class="right-team">
                        <section class="col-md-4">
                            <img src="@/assets/img/team/bobby.jpg" alt="Bobby Thompson">
                        </section>
                        <section class="col-md-8">
                            <blockquote>
                                Lorem ipsum dolor sit amet, to the taskmaster I shall not submit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                            </blockquote>
                            <p>
                                <strong>Robert Thompson PhD</strong>, Technical Director
                            </p>
                        </section>
                    </div>
                    <div class="left-team">
                        <section class="col-md-4">
                            <img src="@/assets/img/team/Elloa.jpg" alt="Elloa">
                        </section>
                        <section class="col-md-8">
                            <blockquote>
                                I play only MMORPGs. What interests me in games is to see my character taking life in a new world and observe it evolving among others doing just the same. An allegory to life and our human condition, basically.
                            </blockquote>
                            <p>
                                <strong>Elloa</strong>, Community Manager
                            </p>
                        </section>
                    </div>
                    <div class="right-team">
                        <section class="col-md-4">
                            <img src="@/assets/img/team/Candid.jpg" alt="Candid">
                        </section>
                        <section class="col-md-8">
                            <blockquote>
                                I've been working in the video game industry since 2008 and have loved the majority of it! Games are a great way to bring people together even when they're far apart, which is a fact that grows more important each passing year. The game that sparked my interest in making them was Neverwinter Nights, and it'll always be special to me for that reason.
                            </blockquote>
                            <p>
                                <strong>Candid</strong>, Art Director
                            </p>
                        </section>
                    </div>
                    <div class="left-team">
                        <section class="col-md-4">
                            <img src="@/assets/img/team/andrew.jpg" alt="Andrew Phippen">
                        </section>
                        <section class="col-md-8">
                            <blockquote>
                                EQ, AC2 and FFXI are what created my addiction to MMO's. Since then I have struggled to find a game that gave that same sense of teamwork based gameplay and sparked that sense of adventure. My goal is to try and help bring that passion back to MMO's so we can all once again make friends that share that adventure together in a whole new massively multiplayer experience.
                            </blockquote>
                            <p>
                                <strong>Andrew Phippen</strong>, World Designer
                            </p>
                        </section>
                    </div>
                    <div class="right-team">
                        <section class="col-md-4">
                            <img src="@/assets/img/team/JoeProfilePic.jpg" alt="Joe Bennett">
                        </section>
                        <section class="col-md-8">
                            <blockquote>
                                Seeing the great works of Simon Bisley and Frank Fazetta started me on the path of becoming an artist. This journey has led me to having the opportunity to work with a fantastic group of people that inspire me just as much! I hope to pass on that experience to all and continue this journey together...CHEERS!
                            </blockquote>
                            <p>
                                <strong>Joe Bennett</strong>, Artist
                            </p>
                        </section>
                    </div>
                    <div class="left-team">
                        <section class="col-md-4">
                            <img src="@/assets/img/team/rob.jpg" alt="Rob Bednarek">
                        </section>
                        <section class="col-md-8">
                            <blockquote>
                                As a long time fantasy fan, first in video games, then comics, and LotR to D&amp;D, I'm excited to have the opportunity to try to bring that shared adventuring and dungeon-crawling experience to life in a fresh way for both old fans and new ones alike.
                            </blockquote>
                            <p>
                                <strong>Rob Bednarek</strong>, Lead Character Artist
                            </p>
                        </section>
                    </div>
                    <div class="right-team">
                        <section class="col-md-4">
                            <img src="@/assets/img/team/Franklin-3.jpg" alt="Franklin Ball">
                        </section>
                        <section class="col-md-8">
                            <blockquote>
                                Video games are such and incredibly engaging way to tell a story. I love playing video games where I can feel emotionally connected to the characters like the last of us and undertale. I've laughed, I've cried and I have met so many of my close friends through video games. I have so many great memories playing video games, from going to super smash bros tournaments, to getting my mom hooked on super monkey ball, there really is a game out there for every kind of person.
                            </blockquote>
                            <p>
                                <strong>Franklin Ball</strong>, Environmental Artist
                            </p>
                        </section>
                    </div>
                    <div class="left-team">
                        <section class="col-md-4">
                            <img src="@/assets/img/team/richard.jpg" alt="Richard Kuhn">
                        </section>
                        <section class="col-md-8">
                            <blockquote>
                                I remember growing up and watching the old animated Hobbit and Lord of the ring movies from the late seventies. Those pastimes drew me into the fantasy genre and now I am excited to bring that sense of social adventure to a new generation.
                            </blockquote>
                            <p>
                                <strong>Richard Kuhn</strong>, Programmer
                            </p>
                        </section>
                    </div>
                    <div class="right-team">
                        <section class="col-md-4">
                            <img src="@/assets/img/team/seth.jpg" alt="Seth Anderson">
                        </section>
                        <section class="col-md-8">
                            <blockquote>
                                I guess I've always wanted to make games: from old notebook "games" to horrendously unplayable HeroQuest quests to early school writing assignments that were really just crude adaptations of my experiences in Ultima games. Recreating that sense of inhabiting another world, something which games are uniquely suited to, has been a lifelong fascination.
                            </blockquote>
                            <p>
                                <strong>Seth Anderson</strong>, Programmer
                            </p>
                        </section>
                    </div>
                    <div class="left-team">
                        <section class="col-md-4">
                            <img src="@/assets/img/team/adric.jpg" alt="Jonathan 'Adric' Zink">
                        </section>
                        <section class="col-md-8">
                            <blockquote>
                                MMORPGs have always had a special place in my heart. From the naive beginnings of Ultima Online through Everquest and World of Warcraft, with countless titles between and beyond. I have always been a fan of RPGs, but these games offered me something more, something I had only experienced while sitting around a table playing Dungeons and Dragons. A bond between friends and family forged and strengthened through hardships and challenge in a world of adventure and wonder. This is the experience I aim to instill into my work to share with you all!!!
                            </blockquote>
                            <p>
                                <strong>Jonathan "Adric" Zink</strong>, Game Design
                            </p>
                        </section>
                    </div>
                    <div class="right-team">
                        <section class="col-md-4">
                            <img src="@/assets/img/team/wade.jpg" alt="Wade">
                        </section>
                        <section class="col-md-8">
                            <blockquote>
                                There is power in stories. Power to see strange new horizons, to live impossible experiences, to be an utterly different version of yourself. I hope to tell stories that immerse players in this strange new land, and to connect with the people they meet there. But most importantly, I want to help players craft their own epic tales as they journey through the world of Embers Adrift.
                            </blockquote>
                            <p>
                                <strong>Wade</strong>, Lead Narrative Designer
                            </p>
                        </section>
                    </div>
                    <div class="left-team">
                        <section class="col-md-4">
                            <img src="@/assets/img/team/morrolantv.jpg" alt="Morrolan TV">
                        </section>
                        <section class="col-md-8">
                            <blockquote>
                                An MMO fanatic since 1997, with a special love for old school games such as Meridian 59, Ultima Online, Everquest, and Asheron's Call. I also have a deep appreciation for the narrative storytelling in games like Final Fantasy, and the more subtle, context-based storytelling from games like Dark Souls and Hollow Knight. I hope to bring you memorable characters, meaningful choices, and unexpected secrets as you adventure through our world.
                            </blockquote>
                            <p>
                                <strong>Morrolan TV</strong>, Narrative Designer
                            </p>
                        </section>
                    </div>
                </div>
            </section>
        </div>
        <div class="Divider">
            <hr class="Divider-rule">
        </div>
        <div class="row pattern">
            <div class="container" style="padding-bottom: 4em;">
                <div class="row">
                    <h2>Contact Us</h2>
                    <div class="row">
                        <div style="text-align: center; color: white;">
                            Drop us an email at the address below<br />Or just pop over to our <a href="https://forums.embersadrift.com">forums</a> or <a href="https://discord.gg/frvyp3b9ex" target="_blank" >Discord Server</a>
                        </div>
                        <div style="text-align: center; padding-top: 2em;">
                            <a href="mailto:Support@embersadrift.com">Support@embersadrift.com</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'TeamComponent',
        data() {
            return {
            
            }
        }, 
    }
</script> 